import React, { FC, useCallback, useEffect } from "react";
import styles from "./styles.module.less";
import { PersonalCenterHeader } from "@/components/PersonalCenterHeader";
import { IconFont } from "../IconFont";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { message, Modal } from "antd";
import { useNavigate, useLocation } from "react-router";
import qs from "query-string";
import classNames from "classnames";

export interface LaunchpadLayoutProps {
  children?: React.ReactNode;
}

export const LaunchpadLayout: FC<LaunchpadLayoutProps> = ({
  children,
}: LaunchpadLayoutProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const nav = useNavigate();

  const onLogout = useCallback(async () => {
    if (await window.__authing__.getCurrentUser()) {
      await window.__authing__.logout();
    } else {
      await axios.post("/logout");
    }
    message.success(t("common.logoutSuccess"));
    setTimeout(() => {
      let redirect = "/login";
      if (window.__config__.logoutRedirectUris?.length) {
        redirect = window.__config__.logoutRedirectUris[0];
      }
      window.location.href = redirect;
    }, 500);
  }, [t]);

  const showLogout = useCallback(() => {
    Modal.warning({
      title: t("common.confirmLogout"),
      okCancel: true,
      onOk: onLogout,
    });
  }, [onLogout, t]);

  useEffect(() => {
    if (Number(qs.parse(location.search).logout)) {
      window.__authing__.getCurrentUser().then((v) => {
        if (v) {
          showLogout();
        }
      });
    }
  }, [location.search, showLogout]);

  const gotoLaunchpad = () => {
    nav("/launchpad");
  };
  const gotoUserCenter = () => {
    nav("/u");
  };

  const menuConfig = [
    {
      onClick: gotoLaunchpad,
      content: (
        <>
          <IconFont
            type="authing-aspect-ratio-line"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.appPanel")}
        </>
      ),
      unShow: () => {
        let address = window.location.pathname === "/launchpad";
        let c = window.__config__;
        let isRoot = c.userPoolId === c.rootUserPoolId;
        return address || isRoot;
      },
    },
    {
      onClick: gotoUserCenter,
      content: (
        <>
          <IconFont
            type="authing-user-line1"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.personalCenter")}
        </>
      ),
      unShow: () => window.location.pathname === "/u",
    },
    {
      onClick: showLogout,
      content: (
        <>
          <IconFont
            type="authing-logout-circle-r-line"
            style={{ fontSize: 14, marginRight: 6 }}
          />
          {t("common.logout")}
        </>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      <PersonalCenterHeader menuConfig={menuConfig} />
      <main className={classNames(styles.main)}>
        <div className={styles.content}>{children}</div>
      </main>
    </div>
  );
};
